import { NavLink } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Homepage = () => {
    return (
        <div className="container">
            <Navbar />
            <div className="homepage-banner">
                <div className="text">Welcome to the Pfizer Alumni Community</div>
            </div>

            <div className="stay_connected">
                <div className="container"> Stay connected with Pfizer and your fellow alumni. Enjoy benefits, take part in Pfizer alumni events and find out about job opportunities at Pfizer*.</div>
            </div>

            <div className="auto-scroll">
                <div className="auto-scroll-inner">
                    {[1, 2, 3, 4, 5, 1, 2, 3, 4, 5].map((n, i) => (
                        <div className="img-container" key={i}>
                            <picture>
                                <source srcSet={`/assets/auto-scroll/${n}.webp`} type="image/webp" />
                                <img src={`/assets/auto-scroll/${n}.png`} alt="auto-scroll" />
                            </picture>
                        </div>
                    ))}
                </div>
            </div>

            <div className="message-from">
                <div className="img-container">
                    <picture>
                        <source srcSet="/assets/message-from.webp" type="image/webp" />
                        <img src="/assets/message-from.png" alt="message-from" loading="lazy" />
                    </picture>
                </div>
                <div className="message">
                    <div className="title" style={{ marginBottom: "20px" }}>A message from Sherry Cassano</div>
                    <div className="content">
                        <div className="paragraph">It’s truly a joy to welcome you to the Pfizer Alumni Community. No matter where your journey has taken you into new roles, new industries, new cities, or new passions, you will always remain a valued member of the Pfizer family. Your contributions have helped move our purpose forward: breakthroughs that change patients’ lives. That impact stays with us.</div>
                        <div className="paragraph">In a world changing faster than ever, the strength of our connections matters deeply. This Alumni Community was created with that spirit in mind to keep us close, inspired, and learning from one another. Whether you are exploring new opportunities, sharing your expertise, seeking mentorship, or reconnecting with colleagues who shaped your path, there is a place for you here.</div>
                        <div className="paragraph">At its heart, this community is about you. Your experience, your perspective, and your continued ability to use your power for purpose make a meaningful difference wherever your journey leads next. We also want to continue to keep you updated on the exciting progress of our work and ensure you feel connected to the continued progress of the work that you did while you were here.</div>
                        <div className="paragraph">Thank you for everything you have given to Pfizer and for everything you continue to contribute to the world beyond it. We’ll continue to keep the Alumni community in the loop on what’s happening at Pfizer and I invite you to stay engaged, share your journey, and help us build a vibrant network of leaders and changemakers.</div>
                        <div className="paragraph">We are grateful to have you with us, and we look forward to staying connected.</div>
                        <div >Sherry Cassano <br />Chief Talent Officer, SVP People Experience US and International Commercial People Experience</div>
                    </div>
                </div>
            </div>

            <div className="about-pfizer">
                <div className="title">About Pfizer Alumni Community</div>
                <div className="cards">
                    <div className="card">
                        <div className="img-container">
                            <picture>
                                <source srcSet="/assets/cards/1.webp" type="image/webp" />
                                <img src="/assets/cards/1.png" alt="about-pfizer" loading="lazy" />
                            </picture>
                        </div>
                        <div className="description">
                            <div className="title">Vision</div>
                            <div className="content">Create the best-in-class Corporate Alumni Community that facilitates connections, growth, and support for Pfizer colleagues on their journey from the time they join Pfizer to after the departure.</div>
                        </div>
                    </div>
                    <div className="card">
                        <div className="img-container">
                            <picture>
                                <source srcSet="/assets/cards/2.webp" type="image/webp" />
                                <img src="/assets/cards/2.png" alt="about-pfizer" loading="lazy" />
                            </picture>
                        </div>
                        <div className="description">
                            <div className="title">Mission</div>
                            <div className="content">To build a vibrant alumni community where invited Pfizer colleagues can stay connected, contribute to a better future, and feel supported throughout their life journey via the Pfizer Alumni Community.</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="map">
                <div style={{ position: 'absolute', top: '50%', left: '10.5%', width: '12%' }} className="img-container"><img src="/assets/usa-map/c_35.svg" alt="usa_map" /></div>
                <div style={{ position: 'absolute', top: '6.76%', left: '63%', width: '12%' }} className="img-container"><img src="/assets/usa-map/c_33.svg" alt="usa_map" /></div>
                <div style={{ position: 'absolute', top: '6%', left: '86%', width: '13.4%' }} className="img-container"><img src="/assets/usa-map/c_139.svg" alt="usa_map" /></div>
                <div style={{ position: 'absolute', top: '44%', left: '77%', width: '7.2%' }} className="img-container"><img src="/assets/usa-map/c_59.svg" alt="usa_map" /></div>

                <div style={{ position: 'absolute', top: '66.17%', left: '78.6%', width: '5.82%' }} className="img-container"><img src="/assets/usa-map/b_6.svg" alt="usa_map" /></div>
                <div style={{ position: 'absolute', top: '73.8%', left: '47%', width: '5.82%' }} className="img-container"><img src="/assets/usa-map/b_9.svg" alt="usa_map" /></div>
                <div style={{ position: 'absolute', top: '83%', left: '84%', width: '5.82%' }} className="img-container"><img src="/assets/usa-map/b_12.svg" alt="usa_map" /></div>
                <div style={{ position: 'absolute', top: '16.5%', left: '22.84%', width: '54.5%' }} className="img-container"><img src="/assets/usa-map/b_group.svg" alt="usa_map" /></div>

                <div className="explore-container">
                    <div className="text">Alumni Locations</div>
                    <a href="https://pfizer.almaconnect.com/" target="_blank" className='explore' rel="noreferrer">Explore Network Online with Alums</a>
                </div>
            </div>

            {/* <AlumniSearchBar /> */}

            {/* <div className="pfizer-in-news">
        <div className="cards">
            <div className="card1">
                <div className="title">
                    <div style={{fontSize: 'clamp(18px, 1.806vw, 26px)',fontWeight: 500, lineHeight: '150%', color: '#000000'}}>Pfizer in the News</div>
                    <a href="#" style={{fontSize: 'clamp(14px, 1.25vw, 18px)',fontWeight: 400, lineHeight: '81%', color: '$light-blue'}}>View all</a>
                </div>
                <div className="content-container" style={{marginBottom: '7px'}}>
                    <div style={{marginBottom: '3px',fontSize: 'clamp(12px, 1.25vw, 18px)',fontWeight: 400, lineHeight: '135%', color: '##606060'}}>April 29, 2021</div>
                    <div style={{marginBottom: '3px',fontSize: 'clamp(12px, 1.25vw, 18px)',fontWeight: 700, lineHeight: '135%', color: '#000000'}}>J&J Boosts Outlook As Strong Overseas Sales Lift Results</div>
                    <div style={{fontSize: 'clamp(12px, 1.25vw, 18px)',fontWeight: 400, lineHeight: '135%', color: '#606060'}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque consequat dolor non malesuada mollis. Etiam posuere dolor id arcu commodo... 
                        <a href="#" style={{color: '$light-blue'}}>Read more</a></div>
                </div>
                <div className="content-container" style={{marginBottom: '7px'}}>
                    <div style={{marginBottom: '3px',fontSize: 'clamp(12px, 1.25vw, 18px)',fontWeight: 400, lineHeight: '135%', color: '##606060'}}>April 29, 2021</div>
                    <div style={{marginBottom: '3px',fontSize: 'clamp(12px, 1.25vw, 18px)',fontWeight: 700, lineHeight: '135%', color: '#000000'}}>J&J Boosts Outlook As Strong Overseas Sales Lift Results</div>
                    <div style={{fontSize: 'clamp(12px, 1.25vw, 18px)',fontWeight: 400, lineHeight: '135%', color: '#606060'}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque consequat dolor non malesuada mollis. Etiam posuere dolor id arcu commodo... 
                        <a href="#" style={{color: '$light-blue'}}>Read more</a></div>
                </div>
                <div className="content-container">
                    <div style={{marginBottom: '3px',fontSize: 'clamp(12px, 1.25vw, 18px)',fontWeight: 400, lineHeight: '135%', color: '##606060'}}>April 29, 2021</div>
                    <div style={{marginBottom: '3px',fontSize: 'clamp(12px, 1.25vw, 18px)',fontWeight: 700, lineHeight: '135%', color: '#000000'}}>J&J Boosts Outlook As Strong Overseas Sales Lift Results</div>
                    <div style={{fontSize: 'clamp(12px, 1.25vw, 18px)',fontWeight: 400, lineHeight: '135%', color: '#606060'}}>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque consequat dolor non malesuada mollis. Etiam posuere dolor id arcu commodo... 
                        <a href="#" style={{color: '$light-blue'}}>Read more</a></div>
                </div>
            </div>
            <div className="card2">
                <div className="title">Recently Joined</div>
                <div className="profiles">
                    <img src="/assets/search-alum/profiles.png" alt="profile" />
                </div>
                <div className="read-more">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque consequat dolor non malesuada mollis. Etiam posuere dolor id arcu commodo... <span style={{color: '$light-blue'}}>Read more</span></div>
            </div>
        </div>
    </div> */}

            {/* <div className="support">
        <div className="title">Support</div>
        <div className="grid">
            <div className="d_1" style={{fontWeight: 700, lineHeight: '135%', color: '#606060'}}>Benefits</div>
            <div className="d_2" style={{fontWeight: 400, lineHeight: '135%', color: '#606060'}}>netbenefits.com<br/>+1-877-208-0950</div>
            <div className="d_3" style={{fontWeight: 700, lineHeight: '135%', color: '#606060'}}>Adverse Events</div>
            <div className="d_4" style={{fontWeight: 400, lineHeight: '135%', color: '$light-blue'}}>Pfizer's Adverse Event Reporting Portal</div>
        </div>
    </div> */}

            <div className="contact-us-container"><NavLink to="https://www.pfizer.com/contact" target="_blank">Contact Us</NavLink></div>

            <Footer />
        </div>);
};
export default Homepage;